<template>
  <v-layout align-center justify-center fill-height>
    <v-col cols :sm="4">
      <v-form v-model="Login.isValid" @submit.prevent="_fnLogin()" ref="form">
        <v-card tile>
          <v-card-text>
            <v-col cols :sm="12" class="py-1 d-flex justify-center">
              <span><v-img :width="60" :height="60" src="/favicon.png" /></span>
            </v-col>
            <v-col cols :sm="12" class="py-1 d-flex justify-center">
              <h1>LOMO LGBT+</h1>
            </v-col>
          </v-card-text>
          <v-card-text>
            <v-text-field
              :label="$t(`loginPage.username`)"
              name="username"
              v-model="Login.obj.username"
              required
              :rules="[Rules.required]"
              prepend-icon="mdi-account"
            />
            <v-text-field
              :label="$t(`loginPage.password`)"
              name="password"
              v-model="Login.obj.password"
              required
              :rules="[Rules.required, Rules.minPass]"
              prepend-icon="mdi-lock"
              @click:append="() => (vis = !vis)"
              :append-icon="`mdi-eye${vis ? '-off' : ''}`"
              :type="vis ? 'password' : ''"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              tile
              block
              type="submit"
              color="primary"
              :disabled="!Login.isValid"
            >
              {{ $t(`loginPage.loginBtn`) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      model: "Login",
      vis: true,
    };
  },
  methods: {
    async _fnLogin() {
      const { data } = await this.fnPost({
        url: "/v1/admin/login",
        model: this.model,
      });
      if (data) {
        await this.fnSetToken(data);
        this.$router.push("/");
      }
      this.$refs.form.reset();
    },
  },
};
</script>
